<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Substeps
import Umsaekjandi from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import PEP from '../../Shared/PEP.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
  onnurRettindi?: unknown
}>()

const rules = {
  umsokn: {
    confirm: { sameAs: sameAs(true) }
  }
}

const expanded = ref([0]) 

const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn" class="col-sm-12">
    <v-col>
      <!-- Header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('lifeyri_umsokn_step6_header1') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Intro -->
      <v-row>
        <v-col>
          <p>{{ t('lifeyri_umsokn_step6_header2') }}</p>
        </v-col>
      </v-row>

      <!-- Summary expansion -->
      <v-row>
        <v-col class="application__summary">
          <v-expansion-panels v-model="expanded">
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ t('lifeyri_umsokn_step6_um_umsokn') }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div><Umsaekjandi :umsokn="umsokn" :disable="true" /></div>
                <div class="m-t-100"><Step2 :umsokn="umsokn" :disable="true" /></div>
                <div class="m-t-100"><Step3 :umsokn="umsokn" :disable="true" /></div>
                <div class="m-t-100"><Step4 :umsokn="umsokn" :disable="true" :onnurRettindi="props.onnurRettindi" /></div>
                <div class="m-t-100"><Step5 :umsokn="umsokn" :disable="true" /></div>
                <div class="m-t-100"><PEP :showDisclamer="false" :umsokn="umsokn" :disable="true" /></div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Agreement header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('lifeyri_umsokn_step6_header3') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Checkbox -->
      <v-row>
        <v-col>
          <v-checkbox
            v-model="umsokn.confirm"
            :label="t('lifeyri_umsokn_step6_skilmalar')"
            :readonly="props.disable"
            :error="v$.umsokn.confirm.$error"
            :error-messages="
              v$.umsokn.confirm.$error
                ? [t('lan_umsokn_step7_confirm_error')]
                : []
            "
          />
        </v-col>
      </v-row>

      <!-- Disclaimer -->
      <v-row>
        <v-col>
          <p class="forms__paragraph">
            {{ t('lifeyri_umsokn_step6_disclaimer_text') }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
